<div class="field">
    @if (!asSelect) {
        <input
                [type]="type"
                [placeholder]="placeholder"
                [(ngModel)]="value"
                (ngModelChange)="onValueChange()"
                [id]="id"
                [disabled]="disabled"
                [maxlength]="maxlength"
        />
    } @else {
        <select
                [(ngModel)]="value"
                (ngModelChange)="onValueChange()"
                [id]="id"
                [disabled]="disabled"
        >
            @for (opt of options; track opt.key) {
                <option [ngValue]="opt.key">{{opt.value ?? opt.key}}</option>
            }
        </select>
    }
    <label [htmlFor]="id">{{label}}</label>
</div>
